import { store } from '.'

export const getRelationships = (id: string, included?: any) => {
  if (!!included && included.length > 0) {
    return included?.find((component: any) => component.id === id)
  }

  return store.included?.find((component: any) => component.id === id)
}
